import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ServicioFacturacionOtroService, ObjectRequestFacturacion } from 'src/app/services/servicio-facturacion-otro.service';
import { ServicioImagenesService, ObjetoImagenesEntity } from '../../../services/servicio-imagenes.service';
import {
  ServicioImprimirAdmisionService,
  ParametrosImprimirAdmisionEntity,
  EntidadEmpresarial,
  InformacionUsuarioEntity
} from 'src/app/services/servicio-imprimir-admision.service';

@Component({
  selector: 'app-reporte-factura-venta',
  templateUrl: './reporte-factura-venta.component.html',
  styleUrls: ['./reporte-factura-venta.component.css']
})
export class ReporteFacturaVentaComponent implements OnInit {
  
  private parametrosUrl: ParametrosImprimirAdmisionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: '',
    uncoAdmision: ''
  };

  public dataFormaPago: any;
  public data: any;
  public valorTotal: any;
  public valor: any;
  public fechaImpresion: Date = new Date();
  public uncoTransaccion: string;
  public tipoDocumento: string;
  public detalleServicio: string;
  public detalleCero: string;
  public dataKeys: any[] = [];
  public dataReporte: any;
  public dataEntidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: ''
  };
  public dataUsuario: InformacionUsuarioEntity = {
    nombreUsuario: '',
    codigoBarrasImprime: ''
  };

  constructor(
    private servicioAdmision: ServicioImprimirAdmisionService,
    private servicioFacturacion: ServicioFacturacionOtroService,
    private servicioImagenes: ServicioImagenesService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.parametrosUrl.codigoBaseDatos = params.codigoBaseDatos;
      this.parametrosUrl.uncoSede = params.uncoSede;
      this.parametrosUrl.uncoLogin = params.uncoLogin;
      this.uncoTransaccion = params.uncoTransaccion;
      this.tipoDocumento = params.tipoDocumento;
    });
  }

  ngOnInit() {
    this.getInfoEntidadEmpresarial();
    this.getFacturacionOtro();
    this.getInfoUsuario();
    this.getFacturacionOtroData();
    this.getFacturacionFormaPago();
  }

  public getPrint() {
    window.print();
  }

  public getCalcularTotalUnitario() {
    this.valor = 0;
    this.dataKeys.forEach(key => {
      this.dataReporte[key].forEach(data => {
        this.valorTotal = (data.valorUnitario * data.cantidad);
        this.valor += this.valorTotal;
      });
    });
  }

  /* Consumir Servicio */

  private async getInfoEntidadEmpresarial() {
    const response = await this.servicioAdmision.getEntidadEmpresarial(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataEntidadEmpresarial = data[0];
      }
      // console.log(this.dataEntidadEmpresarial);
    }, error => {
      console.log(error);
    });
  }

  private async getInfoUsuario() {
    const response = await this.servicioAdmision.getInformacionUsuario(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataUsuario = data[0];
      }
      // console.log(this.dataUsuario);
    }, error => {
      console.log(error);
    });
  }

  private async getFacturacionOtro() {
    const params: ObjectRequestFacturacion = {
      uncoTracnsaccion: this.uncoTransaccion,
      tipoDocumento: this.tipoDocumento,
      detalleServicio: '1', /* this.detalleServicio, */
      detalleCero: '1'/* this.detalleCero */
    };

    const response = await this.servicioFacturacion.getFacturacionOtro(this.parametrosUrl.codigoBaseDatos, params);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataKeys = Object.keys(data);
        this.dataReporte = data;
        this.getCalcularTotalUnitario();
      }
      // console.log(data);
    }, error => {
      console.log(error);
    });
  }

  private async getFacturacionOtroData() {
    const params: ObjectRequestFacturacion = {
      uncoTracnsaccion: this.uncoTransaccion,
      tipoDocumento: this.tipoDocumento,
      detalleServicio: '1', /* this.detalleServicio, */
      detalleCero: '1'/* this.detalleCero */
    };

    const response = await this.servicioFacturacion.getFacturacionOtroData(this.parametrosUrl.codigoBaseDatos, params, this.parametrosUrl.uncoLogin);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.data = data['#result-set-1'][0];
        // console.log(data['#result-set-1'][0]);
      }
      // console.log(data);
    }, error => {
      console.log(error);
    });
  }

  private async getFacturacionFormaPago() {
    const params: ObjectRequestFacturacion = {
      uncoTracnsaccion: this.uncoTransaccion,
      tipoDocumento: this.tipoDocumento,
      detalleServicio: '1', /* this.detalleServicio, */
      detalleCero: '1'/* this.detalleCero */
    };

    const response = await this.servicioFacturacion.getFacturacionFormaPago(this.parametrosUrl.codigoBaseDatos, params);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataFormaPago = data['#result-set-1'][0];
        // console.log(data['#result-set-1'][0]);
      }
      // console.log(this.dataFormaPago);
    }, error => {
      console.log(error);
    });
  }

  private async getLogoReporte() {

    const params: ObjetoImagenesEntity = {
      codigoBaseDatos: this.parametrosUrl.codigoBaseDatos,
      idEntidad: '',
      id: ''
    };

    const response = await this.servicioImagenes.getResponseImagenes(params);

    response.subscribe( (data: any) => {
      console.log(data);
    }, error => {
      console.log(error);
    });
  }

}
